import React, { useEffect } from "react";
import { Box, BoxProps } from "@mui/material";

interface PageProps extends BoxProps {
  children: React.ReactNode;
  title?: string;
  icon?: string;
}

const Page: React.FC<PageProps> = ({
  children,
  title = "",
  icon,
  ...other
}) => {
  useEffect(() => {
    // Cambiar el título de la página
    document.title = `${title} | Facturación Electrónica`;

    // Cambiar el ícono de la página si se proporciona
    if (icon) {
      const link = document.querySelector(
        "link[rel*='icon']"
      ) as HTMLLinkElement | null;
      if (link) {
        link.href = icon;
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = icon;
        document.head.appendChild(newLink);
      }
    }
  }, [title, icon]);

  return <Box {...other}>{children}</Box>;
};

export default Page;
